import { z } from 'zod';

export const DataSetVersionStatuses = [
  'NotStarted',
  'Processing',
  'Failed',
  'Complete',
] as const;

export const DataSetVersionStatus = z.enum(DataSetVersionStatuses);

export type DataSetVersionStatus = z.infer<typeof DataSetVersionStatus>;
